import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import Cookies from "universal-cookie";
import { UsersContext } from "../Components/Context/UsersContext";
import { userIsAllowed } from "../Utils/userIsAllowed";

const PrivatesRoute = ({
  minRole,
  component: Component,
  location,
  actionsIdAllowed,
  ...rest
}) => {
  const { currentUser, isLoadingUser } = useContext(UsersContext);
  const cookies = new Cookies();

  const enroutingPage = (props) => {
    if (!cookies.get("jes"))
      return (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: location },
          }}
        />
      );

    if (isLoadingUser) {
      return <>Cargando ...</>;
    } else if (
      currentUser.roleId <= minRole && actionsIdAllowed
        ? userIsAllowed(currentUser, actionsIdAllowed)
        : true
    ) {
      return <Component {...props} />;
    } else {
      return <div>Pagina no encontrada</div>;
    }
  };

  return (
    <>
      <Route {...rest} render={(props) => enroutingPage(props)}></Route>
    </>
  );
};

export default PrivatesRoute;
